import { styled } from '@mui/material/styles';
import { ViewBusinessHours } from './ViewBusinessHours';
import EditBusinessHours from './EditBusinessHours';

const PREFIX = 'BusinessHours';

const classes = {
  container: `${PREFIX}-container`,
  wrapper: `${PREFIX}-wrapper`,
};

const Root = styled('div')({
  [`& .${classes.container}`]: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    fontSize: '14px',
  },
  [`&.${classes.wrapper}`]: {
    paddingTop: '16px',
  },
});

export const BusinessHours = (props) => {
  const { edit, formValue } = props;

  return (
    <Root className={classes.wrapper}>
      <div className="section__header">
        <p className="section__title" style={{ textDecoration: 'underline', fontWeight: 600 }}>
          Business Hours:
        </p>
      </div>
      <div className="section__body">
        <div className={classes.container}>{edit ? <EditBusinessHours value={formValue} /> : <ViewBusinessHours />}</div>
      </div>
    </Root>
  );
};
